package com.xorrus.trading.lot.relayclient.model

import kotlinx.serialization.Serializable
import kotlin.jvm.JvmInline

/**
 * Wire-Wertetypen (Spec §3.5) — strategieübergreifend wiederverwendbar.
 */

/**
 * Exaktes Dezimal-Drahtformat für Preis-/Zonenwerte (`XBigNum`-Herkunft); rechnet nicht.
 * Das Mapping Decimal ↔ XBigNum passiert ausschließlich in `app` — XBigNum (internes
 * JVM-Artefakt) darf in diesem Modul nicht erscheinen (js-Target, §1-Dependency-Regel).
 *
 * [compareTo]/[toDouble] dienen ausschließlich Validierungs- und Anzeigezwecken,
 * nicht der Trading-Arithmetik.
 */
@Serializable
@JvmInline
value class Decimal(val value: String) : Comparable<Decimal> {
    init {
        require(value.matches(WIRE_FORMAT)) { "kein gültiges Dezimal-Drahtformat: '$value'" }
    }

    fun toDouble(): Double = value.toDouble()

    override fun compareTo(other: Decimal): Int = toDouble().compareTo(other.toDouble())

    override fun toString(): String = value

    companion object {
        private val WIRE_FORMAT = Regex("""-?\d{1,15}(\.\d{1,10})?""")
    }
}

/**
 * Geldbetrag mit Währung (ISO-Code aus TWS, z. B. "USD"); [currency] null,
 * solange die Währung desktopseitig (noch) nicht bekannt ist.
 */
@Serializable
data class MonetaryAmount(val value: Decimal, val currency: String? = null)

@Serializable
@JvmInline
value class AccountId(val value: String)

/** [label] ist Anzeigetext aus Desktop-Quelle — vor Anzeige sanitisieren (Protokoll-§7.6). */
@Serializable
data class AccountRef(val id: AccountId, val label: String)

/** Statische Wahl ⇒ Enum, keine Option (§3.5). */
@Serializable
enum class Zone { BEAR, BULL }
